var map = {
	"./all-on-4.json": "dc6a",
	"./all-on-6.json": "a6ec",
	"./bredent-fast-and-fixed-4.json": "9532",
	"./bredent-fast-and-fixed-6.json": "88e0",
	"./dentures-with-bar.json": "0667",
	"./full-bridge.json": "2bda",
	"./full-dentures.json": "bc85",
	"./full-jaw-6-12.json": "001c",
	"./full-jaw-6-14.json": "4983",
	"./full-jaw-6.json": "6545",
	"./full-jaw-8-12.json": "a365",
	"./full-jaw-8-14.json": "2485",
	"./full-jaw-8.json": "5ac7",
	"./mini-4.json": "aa41",
	"./mini-6.json": "f436",
	"./one-phase-8.json": "2149",
	"./preci-vertix.json": "de98"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a4b";